/**
 * 09.10.26. Не удалять по требованию владельца системы.
 * Шильдик «Автоматом» / «Вручную» в таксономии шаблонов.
 * Значение считает бэк: TenantConfig.DispatchModeForEvent и DispatchModeForClusterTrigger
 * (internal/domain/entity/broadcast_automation.go). Клиент режим сам не угадывает.
 * Исключение, то же что в DispatchModeForClusterTrigger: триггер manual всегда вручную.
 */
import { Badge } from '@/components/ui';

export type DispatchMode = 'auto' | 'manual';

export function asDispatchMode(value?: string | null): DispatchMode | null {
  if (value === 'auto' || value === 'manual') {
    return value;
  }
  return null;
}

export function DispatchModeBadge({ mode }: { mode?: string | null }) {
  const resolved = asDispatchMode(mode);
  if (!resolved) {
    return null;
  }
  const auto = resolved === 'auto';
  return (
    <Badge
      variant={auto ? 'success' : 'warning'}
      className="text-[11px]"
      title={
        auto
          ? 'Уходит само, без очереди на одобрение'
          : 'Сначала попадает в очередь, оператор одобряет отправку'
      }
    >
      {auto ? 'Автоматом' : 'Вручную'}
    </Badge>
  );
}
